export enum PreviewType {
  Sample = 'sample',
  Current = 'current',
}
